/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { Select, Box } from '@locus-taxy/neo-ui';

import { rankWith, isEnumControl, or, uiTypeIs } from '@jsonforms/core';

import MaraOnlyTag from '../components/MaraOnlyTag';
import useEnumProps from '../util/useEnumProps';

type Props = {};

const EnumControl = (props: Props): React.Node => {
    const {
        data,
        label,
        description,
        handleChange,
        path,
        enabled,
        schema,
        errors,
        required,
        uischema: { options }
    } = useEnumProps(props);

    const { isMaraOnlyField } = options || {};

    const opts = React.useMemo(() => {
        const values = schema.enum || schema.items.enum;
        return values.map(value => ({
            label: value,
            value
        }));
    }, [schema]);

    const multi = schema.type === 'array';

    return (
        <>
            <Select
                required={required}
                error={errors}
                value={data}
                options={opts}
                label={label}
                placeholder={label}
                disabled={!enabled}
                multiple={multi}
                fullWidth
                helperText={errors ? errors : description}
                onChange={val => {
                    const value = multi
                        ? val.map(({ value }) => value)
                        : val?.value;
                    handleChange(path, value);
                }}
            />
            {isMaraOnlyField && (
                <Box py="1">
                    <MaraOnlyTag />
                </Box>
            )}
        </>
    );
};

export default EnumControl;

export const enumControlTester = rankWith(
    2,
    or(uiTypeIs('EnumControl'), isEnumControl)
);
